export default __webpack_public_path__ + "static/media/chef1.ceb8d6aa.png";